<template>
  <div
    class="listitem uk-width-1-2@m"
    :class="{
      'uk-width-1-3@l': $route.name.indexOf('Kurs') > -1,
      'uk-width-1-4@l': $route.name.indexOf('Kursliste') > -1,
    }"
  >
    <div class="shadowwrap">
      <div class="sidebar_title" uk-grid>
        <span class="kursid uk-width-expand"> Kurs-Nr.: {{ kurs.interneid }} </span>
        <span v-if="kurs.topkurs == 1">
          <svg height="21" width="21">
            <polygon points="21,0 21,21 10,21" style="fill: white" />
          </svg>
          <span class="topkurs">KHI TOPKURS</span>
        </span>
      </div>
      <div class="innerwrap">
        <div class="titel">
          {{ kurs.titel }}
        </div>
        <div class="zeitwrapper has_icon">
          <span class="icon_infront" uk-icon="clock" />
          <div class="start">
            <span class="date">{{ getDateString(kurs.kursstartdatum) }}</span
            >&nbsp;
            <span class="time">{{ kurs.kursstartzeit }}</span>
          </div>
          <div class="end">
            <span class="date">{{ getDateString(kurs.kursenddatum) }}</span
            >&nbsp;
            <span class="time">{{ kurs.kursendzeit }}</span>
          </div>
        </div>
        <div v-if="kurs.voort" class="ort has_icon">
          <span class="icon_infront" uk-icon="location" />
          <div>{{ kurs.voort }}</div>
        </div>
        <div v-if="kurs.fobipunkte" class="fobipkt has_icon">
          <span class="icon_infront" uk-icon="star" />{{ kurs.fobipunkte }} Fortbildungspunkte
        </div>
        <div class="btnwrapper">
          <div class="cta">
            <router-link
              class="uk-button uk-button-default btn_show"
              :to="{ name: 'Kurs', params: { kursnummer: kurs.interneid } }"
            >
              Kurs anzeigen
            </router-link>
          </div>

          <div
            v-if="kurs.ampelstatus == 0"
            style="float: right; text-align: right"
            class="cta button_buch uk-width-1-2"
          >
            <button
              class="uk-button uk-button-default btn_buch test ampel_gruen"
              @click="openBuchenURL(kurs)"
            >
              Direkt buchen
            </button>
          </div>
          <div
            v-if="kurs.ampelstatus == 1"
            style="float: right; text-align: right"
            class="cta button_buch uk-width-1-2"
          >
            <button
              class="uk-button uk-button-default btn_buch test ampel_gelb"
              @click="openBuchenURL(kurs)"
            >
              Restplätze
            </button>
          </div>
          <div
            v-if="kurs.ampelstatus == 2"
            style="float: right; text-align: right"
            class="cta button_buch uk-width-1-2"
          >
            <button
              class="uk-button uk-button-default btn_buch test ampel_rot"
              @click="openBuchenURL(kurs)"
            >
              Voll/Warteliste
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Kurslistitem",
  props: ["kurs"],
  computed: {
    ...mapGetters(["buchungBaseURL1", "buchungBaseURL2"]),
  },
  updated() {
    window.scroll(0, 0);
    console.log("$route.name.indexOf(kurs)", this.$route.name, this.$route.name.indexOf("Kurs"));
  },
  methods: {
    getDateString(tstamp) {
      if (tstamp > 0) {
        const dateObj = new Date(tstamp * 1000);
        return `${dateObj.getDate()}.${dateObj.getMonth() + 1}.${dateObj.getFullYear()}`;
      }
      return "-";
    },
    getTimeString(tstamp) {
      const dateObj = new Date(tstamp * 1000);
      return `${dateObj.getHours() < 10 ? `0${dateObj.getHours()}` : dateObj.getHours()}:${
        dateObj.getMinutes() < 10 ? `0${dateObj.getMinutes()}` : dateObj.getMinutes()
      }`;
    },
    openBuchenURL(kurs) {
      if (kurs.interneid === "25694") {
        window.open(
          "https://www.zahnaerztekammernordrhein.de/bereich/praxisteam/aufstiegsfortbildung-obf-fzp/lehrgang-zur-zum-fzp/",
          "_blank"
        );
      } else if (kurs.interneid === "25588") {
        window.open(
          "https://www.zahnaerztekammernordrhein.de/bereich/praxisteam/aufstiegsfortbildung-obf-fzp/offene-baustein-fortbildung-obf/",
          "_blank"
        );
      } else if (kurs.ingruppe_obf === 1) {
        // https://portal.zaek-nr.de/kursinteresse/<ARTIKEL_NR>
        window.open(this.buchungBaseURL2 + kurs.interneid, "_blank");
      } else {
        // https://portal.zaek-nr.de/kursanmeldung/<ARTIKEL_NR>
        window.open(this.buchungBaseURL1 + kurs.interneid, "_blank");
      }
    },
  },
};
</script>

<style scoped></style>
